import React from 'react';

import * as styled from './styled';

export const Page: React.FC = ({ children }) => <styled.page>{children}</styled.page>;
